import firebase from "firebase/app";

import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { DistributionChannelEmailNotification } from "astrid-firestore/src/api/distribution/types/DistributionChannelEmailNotifcation";
import updateDistributionChannel from "astrid-firestore/src/api/distribution/updateDistributionChannel";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function SuperAdminDistributionChannelEmailNotificationForm({ channel }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: DistributionChannelEmailNotification,
		defaultValues: {
			emailNotificationEnabled: !!channel.emailNotification,
			sendFrom: channel.emailNotification?.sendFrom || "",
			sendTo: channel.emailNotification?.sendTo || "",
			ccTo: channel.emailNotification?.ccTo || "",
			bccTo: channel.emailNotification?.bccTo || "",
			subject: channel.emailNotification?.subject || "",
			messageTemplate: channel.emailNotification?.messageTemplate || "",
		},
		onSubmit: (data) => {
			const { emailNotificationEnabled, ...dataRest } = data;
			if (emailNotificationEnabled) {
				return updateDistributionChannel(firebase, { ref: channel.ref, emailNotification: dataRest });
			} else {
				return updateDistributionChannel(firebase, { ref: channel.ref, emailNotification: null });
			}
		},
	});

	const { error, formState, onSubmit, watch } = form;

	const emailNotificationEnabled = watch("emailNotificationEnabled");

	return (
		<>
			<Header as="h3">{t("emailNotification", "Email notification")}</Header>
			<Form form={form}>
				<Card fluid>
					<Card.Content>
						<Card fluid>
							<Card.Content>
								<Form.Checkbox
									slider
									name="emailNotificationEnabled"
									label={t(
										"distributionChannelEnabledEmailNotification",
										"Aggregated email notification is enabled and will be sent once a day",
									)}
									labelFalse={t(
										"distributionChannelDisabledEmailNotification",
										"Aggregated email notification is disabled",
									)}
								/>
								{emailNotificationEnabled && (
									<>
										<Form.Input
											name="sendFrom"
											label={t("sendFrom", "Send from")}
											shouldUnregister={false}
										/>
										<Form.Input
											name="sendTo"
											label={t("sendTo", "Send to")}
											shouldUnregister={false}
										/>
										<Form.Input name="ccTo" label={t("ccTo", "CC to")} shouldUnregister={false} />
										<Form.Input
											name="bccTo"
											label={t("bccTo", "BCC to")}
											shouldUnregister={false}
										/>
										<Form.Input
											name="subject"
											label={t("subject", "Subject")}
											shouldUnregister={false}
										/>
										<Form.TextArea
											name="messageTemplate"
											label={t("messageTemplate", "Message template")}
											shouldUnregister={false}
										/>
									</>
								)}
								{error && <ErrorMessage error={error} />}
							</Card.Content>

							<Card.Content>
								<PrimaryButton
									disabled={formState.isSubmitting || !formState.isDirty}
									loading={formState.isSubmitting}
									onClick={onSubmit}
								>
									{t("save", "Save")}
								</PrimaryButton>
							</Card.Content>
						</Card>
					</Card.Content>
				</Card>
			</Form>
		</>
	);
}
